// Cash Transactions Actions
import Axios from 'axios'
import * as helpers from '@/mixins/helperFunctions.js'

// ***** Get cash transactions list from backend then update transactionsList in vuex store ***** //
export const fetchCashTransactionList = async ({ commit }, payload = null) => {
  let params = {}

  if (payload) {
    params = {
      search: payload.search,
      page: payload.page,
      per_page: payload.rowsPerPage,
      column: payload.sortBy,
      sortDir: payload.descending ? 'desc' : 'asc'
    }
  }

  try {
    const result = await Axios.get(`cash_transactions_index`, { params: params })
    commit('setCashTransactionList', result.data.data)
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, fetching list data failed')
  }
}

// ***** Fetch cash transaction info ***** //
export const fetchCashTransactionInfo = async ({ commit }, payload = null) => {
  if (!helpers.checkId(payload)) {
    throw new Error('Error')
  }

  try {
    const result = await Axios.get(`cash_transactions_show/${payload}`)
    commit('setCashTransactionInfo', result.data.data)
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, creation failed')
  }
}

// ***** Get cash list from backend then update cash List in vuex store ***** //
export const fetchCashList = async ({ commit }, payload = null) => {
  let cashList = []
  try {
    const result = await Axios.get(`cash_balance_list`, payload)
    result.data.data.forEach(list => {
      cashList.push({
        value: list.outlet_id,
        text: list.outlet_name,
        amount_us: list.amount_us,
        amount_iq: list.amount_iq
      })
    })
    commit('setCashList', cashList)
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, fetching list data failed')
  }
}

// ***** Add cash transaction ***** //
export const addCashTransaction = async (ignored, payload = null) => {
  try {
    await Axios.post('cash_transactions_store', payload)
    helpers.ktNotify({
      type: 'success',
      text: 'Added Successfully'
    })
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, creation failed')
  }
}

// ***** Update cash transaction ***** //
export const updateCashTransactionInfo = async (ignored, payload = null) => {
  if (!helpers.checkId(payload.id)) {
    throw new Error('Error')
  }

  try {
    payload.formData.append('_method', 'PATCH')
    await Axios.post(`cash_transactions_update/${payload.id}`, payload.formData)
    helpers.ktNotify({
      type: 'success',
      text: 'Updated Successfully'
    })
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, update failed')
  }
}

// ***** Delete cash transaction ***** //
export const deleteCashTransaction = async (ignored, payload) => {
  if (!helpers.checkId(payload)) {
    throw new Error('Error')
  }

  try {
    await Axios.delete(`cash_transactions_destroy/${payload}`)
    helpers.ktNotify({
      type: 'success',
      text: 'Deleted Successfully'
    })
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, deletion failed')
  }
}
